import { ActionReducerMapBuilder } from '@reduxjs/toolkit';
import { BrandsState } from '../../types';

import { getFavouriteBrands } from '../operations/getFavouriteBrands';

import { STATUS_LOADING } from 'common/constants';

export const setFavouriteBrands = (builder: ActionReducerMapBuilder<BrandsState>) => builder
  .addCase(getFavouriteBrands.pending, (state) => {
    state.favouriteBrands.loadingStatus = STATUS_LOADING.load;
  })
  .addCase(getFavouriteBrands.fulfilled, (state, { payload }) => {
    state.favouriteBrands.loadingStatus = STATUS_LOADING.done;
    state.favouriteBrands.data = payload.favouriteBrands;
  })
  .addCase(getFavouriteBrands.rejected, (state) => {
    state.favouriteBrands.loadingStatus = STATUS_LOADING.error;
  });
